__turbopack_context__.v({
  "product-attribute-list": "product-attribute-list-component-module-scss-module__hULWaG__product-attribute-list",
  "product-attribute-list__attribute-wrapper": "product-attribute-list-component-module-scss-module__hULWaG__product-attribute-list__attribute-wrapper",
  "product-attribute-list__item-quantity": "product-attribute-list-component-module-scss-module__hULWaG__product-attribute-list__item-quantity",
});
